<template>
  <div class="wrapper">
    <div class="header">
      <div
        class="header--inner "
        :class="{ 'header--bg': [1, 2, 3, 5].includes(reachIndex) }"
      >
        <div class="logo">
          <img :src="require('@/assets/img/jobs/school/logo.png')" alt="" />
        </div>
        <div class="menus">
          <div
            @click="toFullPageSwiper(0)"
            class="menus--item "
            :class="{ on: [0].includes(reachIndex) }"
          >
            首页
          </div>
          <div
            @click="toFullPageSwiper(1)"
            class="menus--item"
            :class="{ on: [1, 2, 3].includes(reachIndex) }"
          >
            闻味松鼠
          </div>
          <div
            @click="toFullPageSwiper(4)"
            class="menus--item"
            :class="{ on: [4].includes(reachIndex) }"
          >
            校招岗位
          </div>
          <div
            @click="toFullPageSwiper(5)"
            class="menus--item"
            :class="{ on: [5].includes(reachIndex) }"
          >
            雇主活动
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="swiper--wrapper">
        <swiper
          ref="fullPageSwiper"
          :style="{ width: screenWidth + 'px', height: screenHeight + 'px' }"
          :options="swiperOption"
        >
          <swiper-slide class="swiper--slide school--page1">
            <div class="bg-page1">
              <div
                :class="{
                  wave: reachIndex === 0
                }"
              >
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_0"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_1"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_2"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_3"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_4"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_5"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_6"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_7"
                ></div>
                <div
                  class="animate__animated animate__infinite wave_animate wave_item wave_item_8"
                ></div>
              </div>
              <div class="wave--center">
                <div
                  ref="waveHead"
                  class="wave--head"
                  :class="[
                    {
                      animate__animated: reachIndex === 0,
                      animate__bounceIn: reachIndex === 0
                    }
                  ]"
                ></div>
                <div
                  ref="waveTitle"
                  class="wave--title"
                  :class="[
                    {
                      animate__animated: reachIndex === 0,
                      animate__bounceIn: reachIndex === 0
                    }
                  ]"
                ></div>
              </div>
            </div>
            <div class="search--box">
              <div class="search--left">
                <input
                  v-model.trim="searchPost1"
                  type="text"
                  placeholder="在此搜索心仪的职位"
                  class="search--input"
                />
                <i class="icon--search"></i>
              </div>
              <div class="search--right" @click="toSearch1">
                搜索
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide school--page2">
            <div
              class="page2--text1 animate__animated "
              style="animation-delay: 1.1s"
              :class="[
                {
                  animate__pulse: reachIndex === 1
                }
              ]"
            >
              让能折腾、耐磨损、有韧性的年轻人在松鼠这个育人平台上跳舞
            </div>
            <div
              class="page2--text2 animate__animated "
              style="animation-delay: 1.4s"
              :class="[
                {
                  animate__pulse: reachIndex === 1
                }
              ]"
            >
              让平凡的人不平凡，优秀的人更优秀
            </div>
            <div class="title--box">
              <div class="title--text">
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0s"
                  :class="[
                    {
                      animate__bounceInDown: reachIndex === 1
                    }
                  ]"
                >
                  人
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.2s"
                  :class="[
                    {
                      animate__bounceInDown: reachIndex === 1
                    }
                  ]"
                >
                  才
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.4s"
                  :class="[
                    {
                      animate__bounceInDown: reachIndex === 1
                    }
                  ]"
                >
                  理
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.6s"
                  :class="[
                    {
                      animate__bounceInDown: reachIndex === 1
                    }
                  ]"
                >
                  念
                </div>
              </div>
              <div
                class="title--english animate__animated"
                style="animation-delay: 0.8s"
                :class="[
                  {
                    animate__bounceInDown: reachIndex === 1
                  }
                ]"
              >
                Talent concept
              </div>
            </div>
            <div class="corner--top-right">
              <img
                :src="
                  require('@/assets/img/jobs/school/bg-text-threesquirrels.png')
                "
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide school--page3">
            <div class="corner--top-right">
              <img
                :src="require('@/assets/img/jobs/school/bg-arrows-left.png')"
                alt=""
              />
            </div>
            <div class="welfare--box">
              <div
                class="welfare--item  animate__animated"
                style="animation-delay: 0s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--inner">
                  <div class="text--wrap">
                    <div class="text--pingyin">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/pingyin-song.png')
                        "
                        alt=""
                      />
                    </div>
                    <div class="text--hanzi">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/hanzi-song.png')
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="welfare--content">
                    <div class="welfare--row">
                      <p class="welfare--title">六险一金</p>
                      <p class="welfare--explain">(闯荡社会的坚实盾牌)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">CEO与家长们基金</p>
                      <p class="welfare--explain">(松鼠大家庭的专属保障)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">年度体检</p>
                      <p class="welfare--explain">(为鼠员健康保驾护航)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">新人礼包</p>
                      <p class="welfare--explain">(欢迎加入松鼠大家庭)</p>
                    </div>
                  </div>
                </div>
                <div class="welfare--corner">
                  <img
                    :src="
                      require('@/assets/img/jobs/school/icon/pingyin-song.png')
                    "
                    alt=""
                  />
                </div>
              </div>
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0.2s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--inner">
                  <div class="text--wrap">
                    <div class="text--pingyin">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/pingyin-shu.png')
                        "
                        alt=""
                      />
                    </div>
                    <div class="text--hanzi">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/hanzi-shu.png')
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="welfare--content">
                    <div class="welfare--row">
                      <p class="welfare--title">松鼠公寓</p>
                      <p class="welfare--explain">(给你一个安心的住所)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">节日礼包</p>
                      <p class="welfare--explain">(把爱带回家)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">晚间福利</p>
                      <p class="welfare--explain">(填饱肚子才有力气加班)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">专享折扣</p>
                      <p class="welfare--explain">(买给你喜欢的亲朋好友)</p>
                    </div>
                  </div>
                </div>
                <div class="welfare--corner">
                  <img
                    :src="
                      require('@/assets/img/jobs/school/icon/pingyin-shu.png')
                    "
                    alt=""
                  />
                </div>
              </div>
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0.4s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--inner">
                  <div class="text--wrap">
                    <div class="text--pingyin text-left">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/pingyin-fu.png')
                        "
                        alt=""
                      />
                    </div>
                    <div class="text--hanzi">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/hanzi-fu.png')
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="welfare--content">
                    <div class="welfare--row">
                      <p class="welfare--title">生日祝福</p>
                      <p class="welfare--explain">(见证你成长的欢乐)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">团队基金</p>
                      <p class="welfare--explain">(体验集体文化)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">松鼠家庭日</p>
                      <p class="welfare--explain">(关注小家庭的成长与幸福)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">派驻福利</p>
                      <p class="welfare--explain">
                        (走到哪里都带着松鼠的一丝牵挂)
                      </p>
                    </div>
                  </div>
                </div>
                <div class="welfare--corner">
                  <img
                    :src="
                      require('@/assets/img/jobs/school/icon/pingyin-fu.png')
                    "
                    alt=""
                  />
                </div>
              </div>
              <div
                class="welfare--item animate__animated"
                style="animation-delay: 0.6s"
                :class="[
                  {
                    animate__rotateIn: reachIndex === 2
                  }
                ]"
              >
                <div class="item--inner">
                  <div class="text--wrap">
                    <div class="text--pingyin text-left">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/pingyin-li.png')
                        "
                        alt=""
                      />
                    </div>
                    <div class="text--hanzi">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/hanzi-li.png')
                        "
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="welfare--content">
                    <div class="welfare--row">
                      <p class="welfare--title">鼠味相投</p>
                      <p class="welfare--explain">(小资生活的味蕾体验)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">松鼠社团</p>
                      <p class="welfare--explain">(寻找遥远的相似性)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">松鼠身份仪式</p>
                      <p class="welfare--explain">(以传承为使命)</p>
                    </div>
                    <div class="welfare--row">
                      <p class="welfare--title">松鼠假期</p>
                      <p class="welfare--explain">(享受时光的能量补给)</p>
                    </div>
                  </div>
                </div>
                <div class="welfare--corner">
                  <img
                    :src="
                      require('@/assets/img/jobs/school/icon/pingyin-li.png')
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide school--page4">
            <div class="title--box">
              <div class="title--text">
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0s"
                  :class="[
                    {
                      animate__bounceIn: reachIndex === 3
                    }
                  ]"
                >
                  校
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.2s"
                  :class="[
                    {
                      animate__bounceIn: reachIndex === 3
                    }
                  ]"
                >
                  招
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.4s"
                  :class="[
                    {
                      animate__bounceIn: reachIndex === 3
                    }
                  ]"
                >
                  项
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.6s"
                  :class="[
                    {
                      animate__bounceIn: reachIndex === 3
                    }
                  ]"
                >
                  目
                </div>
              </div>
              <div
                class="title--english animate__animated"
                style="animation-delay: 0.8s"
                :class="[
                  {
                    animate__bounceIn: reachIndex === 3
                  }
                ]"
              >
                Campus recruitment program
              </div>
            </div>
            <div class="develop--box">
              <div class="develop--item develop--item1">
                <div class="dev--item--header">
                  <div class="dev--no">1</div>
                  <div class="dev--title">
                    超级松鼠——有股权激励的未来事业合伙人
                  </div>
                </div>
                <div class="dev--content">
                  <div class="dev--text">
                    超级松鼠项目是创始人-松鼠老爹亲自主导设计实施的一项高端人才发展项目，面向松鼠中长期的战略目标，旨在从全球名校中选拔出真正的“高潜人才”加入松鼠成为“未来事业合伙人”。
                  </div>
                </div>
              </div>
              <div class="develop--item develop--item2">
                <div class="dev--item--header">
                  <div class="dev--no">2</div>
                  <div class="dev--title">造星计划——造出核心业务的核心干部</div>
                </div>
                <div class="dev--content">
                  <div class="dev--text">
                    造星计划是三只松鼠为优秀应届毕业生量身制定的管理培训生项目。作为公司战略级人才项目之一，造星计划旨在造出核心业务的核心干部。我们坚持从内部培养出深刻理解松鼠文化、真正熟悉松鼠业务、推动全球化战略落地的中层管理干部。
                  </div>
                </div>
              </div>
              <div class="develop--item develop--item3">
                <div class="dev--item--header">
                  <div class="dev--no">3</div>
                  <div class="dev--title">其他岗位——成为定向岗位的专业人才</div>
                </div>
                <div class="dev--content">
                  <div class="dev--text">
                    通过校园渠道引入某一确定性岗位的应届毕业生。旨在快速培养部门关键岗位的专业化人才。通过专业能力的快速提升，助力业务增长，实现个人发展。
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide school--page5">
            <div class="title--box">
              <div class="title--text">
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0s"
                  :class="[
                    {
                      animate__bounceInLeft: reachIndex === 3
                    }
                  ]"
                >
                  校
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.2s"
                  :class="[
                    {
                      animate__bounceInLeft: reachIndex === 4
                    }
                  ]"
                >
                  招
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.4s"
                  :class="[
                    {
                      animate__bounceInLeft: reachIndex === 4
                    }
                  ]"
                >
                  岗
                </div>
                <div
                  class="text--item animate__animated"
                  style="animation-delay: 0.6s"
                  :class="[
                    {
                      animate__bounceInLeft: reachIndex === 4
                    }
                  ]"
                >
                  位
                </div>
              </div>
              <div
                class="title--english animate__animated"
                style="animation-delay: 0.8s"
                :class="[
                  {
                    animate__bounceInLeft: reachIndex === 4
                  }
                ]"
              >
                School recruitment post
              </div>
            </div>

            <div class="post--box">
              <swiper
                style="height: 440px;"
                :style="{ width: screenWidth + 'px' }"
                :options="swiperOptionPost"
              >
                <swiper-slide
                  :key="'post_' + index"
                  class="post--slide"
                  v-for="(item, index) in postList"
                >
                  <div class="post--item" @click="openUrl(item.url)">
                    <div class="post--icon">
                      <img
                        :src="
                          require('@/assets/img/jobs/school/icon/post-' +
                            item.img +
                            '.png')
                        "
                        :alt="item.name"
                      />
                    </div>
                    <div class="post--name">{{ item.name }}</div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="post-prev"></div>
              <div class="post-next"></div>
            </div>
            <div class="post--search">
              <input
                v-model.trim="searchPost2"
                class="post--input"
                placeholder="在此搜索心仪职位"
                type="text"
              />
              <i class="icon--post--search" @click="toSearch2"></i>
            </div>
          </swiper-slide>
          <swiper-slide class="swiper--slide school--page6">
            <div class="activity--box">
              <div class="activity--tab">
                <div
                  class="tab--item"
                  :class="{ on: activityTab === 1 }"
                  @click="handleActivityTab(1)"
                >
                  宣讲会
                </div>
                <div
                  class="tab--item"
                  :class="{ on: activityTab === 2 }"
                  @click="handleActivityTab(2)"
                >
                  校园大使
                </div>
              </div>
              <div class="activity--content">
                <div class="content--item" v-if="activityTab === 1">
                  <div class="activity--english">
                    <img
                      :src="
                        require('@/assets/img/jobs/school/bg-activity-speak.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="activity--images">
                    <div class="activity--images--left">
                      <div class="activity--image">
                        <div
                          class="activity--image--item"
                          :style="{
                            'background-image': `url(${require('@/assets/img/jobs/school/activity/1.png')})`
                          }"
                        ></div>
                      </div>
                    </div>
                    <div class="activity--images--right">
                      <div class="activity--image">
                        <div
                          class="activity--image--item"
                          :style="{
                            'background-image': `url(${require('@/assets/img/jobs/school/activity/2.png')})`
                          }"
                        ></div>
                      </div>
                      <div class="activity--image">
                        <div
                          class="activity--image--item"
                          :style="{
                            'background-image': `url(${require('@/assets/img/jobs/school/activity/3.png')})`
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content--item" v-if="activityTab === 2">
                  <div class="activity--english">
                    <img
                      :src="
                        require('@/assets/img/jobs/school/bg-activity-school.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="activity--images">
                    <div class="activity--images--left">
                      <div class="activity--image">
                        <div
                          class="activity--image--item"
                          :style="{
                            'background-image': `url(${require('@/assets/img/jobs/school/activity/4.png')})`
                          }"
                        ></div>
                      </div>
                    </div>
                    <div class="activity--images--right">
                      <div class="activity--image">
                        <div
                          class="activity--image--item"
                          :style="{
                            'background-image': `url(${require('@/assets/img/jobs/school/activity/5.png')})`
                          }"
                        ></div>
                      </div>
                      <div class="activity--image">
                        <div
                          class="activity--image--item"
                          :style="{
                            'background-image': `url(${require('@/assets/img/jobs/school/activity/6.png')})`
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="footer" :class="{ on: reachIndex === 5 }">
        <div class="footer--inner">
          <div class="footer--left">
            <div class="footer--row qrcode--box">
              <span>关注三只松鼠招聘官方账号</span>
              <div class="qrcode--list">
                <div class="qrcode--wrap">
                  <img
                    class="qrcode--icon"
                    :src="
                      require('@/assets/img/jobs/school/qrcode/icon-weixin.png')
                    "
                    alt=""
                  />
                  <div class="qrcode--border">
                    <p class="qrcode--title">关注三只松鼠招聘微信公众号</p>
                    <img
                      class="qrcode--img"
                      :src="
                        require('@/assets/img/jobs/school/qrcode/qrcode-weixin.png')
                      "
                      alt=""
                    />
                  </div>
                </div>

                <div class="qrcode--wrap">
                  <img
                    class="qrcode--icon"
                    :src="
                      require('@/assets/img/jobs/school/qrcode/icon-weibo.png')
                    "
                    alt=""
                  />
                  <div class="qrcode--border">
                    <p class="qrcode--title">关注三只松鼠招聘微博公众号</p>
                    <img
                      class="qrcode--img"
                      :src="
                        require('@/assets/img/jobs/school/qrcode/qrcode-weibo.png')
                      "
                      alt=""
                    />
                  </div>
                </div>

                <div class="qrcode--wrap">
                  <img
                    class="qrcode--icon"
                    :src="
                      require('@/assets/img/jobs/school/qrcode/icon-douyin.png')
                    "
                    alt=""
                  />
                  <div class="qrcode--border">
                    <p class="qrcode--title">关注三只松鼠招聘抖音公众号</p>
                    <img
                      class="qrcode--img"
                      :src="
                        require('@/assets/img/jobs/school/qrcode/qrcode-douyin.png')
                      "
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="footer--row">
              招聘邮箱： h_ssxz@3songshu.com
            </div>
          </div>
          <div class="footer--right">
            <div class="footer--right--label">
              <div class="footer--row">松鼠窝地址：</div>
            </div>
            <div class="footer--right--content">
              <div class="footer--row">
                安徽省芜湖市弋江区高新技术产业开发区久盛路8号
              </div>
              <div class="footer--row">
                江苏省南京市鼓楼区集庆门大街268号苏宁慧谷中心E07-2-40F
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左侧边nav -->
      <div class="nav--sidebar" :class="{ on: [1, 2, 3].includes(reachIndex) }">
        <div
          @click="toFullPageSwiper(1)"
          class="side--item"
          :class="{ on: [1].includes(reachIndex) }"
        >
          人才理念
        </div>
        <div
          @click="toFullPageSwiper(2)"
          class="side--item"
          :class="{ on: [2].includes(reachIndex) }"
        >
          松鼠福利
        </div>
        <div
          @click="toFullPageSwiper(3)"
          class="side--item"
          :class="{ on: [3].includes(reachIndex) }"
        >
          校招项目
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import animated from "animate.css";
Vue.use(animated);
export default {
  name: "jobs-school",
  data() {
    return {
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      slideStyle: {
        width: document.body.clientWidth + "px",
        height: document.body.clientHeight + "px"
      },
      swiperOption: {
        direction: "vertical",
        mousewheel: true,
        keyboardControl: true,
        mousewheelControl: true,
        simulateTouch: false,
        createPagination: false,
        paginationClickable: true,
        speed: 700,
        initialSlide: 0,
        on: {
          slideChange: () => {
            let swiper = this.$refs.fullPageSwiper.$swiper;
            if (swiper) {
              this.reachIndex = swiper.activeIndex;
            }
          }
        }
      },
      swiperOptionPost: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        initialSlide: 3,
        autoplay: {
          delay: 2000
        },
        navigation: {
          prevEl: ".post-prev",
          nextEl: ".post-next"
        }
      },
      activityTab: 1,
      reachIndex: 0,
      searchPost1: "",
      searchPost2: "",
      postList: [
        {
          img: "wuliu",
          name: "供应链/物流类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=13988&page=1"
        },
        // {
        //   img: "shengchan",
        //   name: "生产/制造类",
        //   url:
        //     "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=6595&page=1"
        // },
        {
          img: "zhineng",
          name: "职能类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=6593&page=1"
        },
        {
          img: "chanping",
          name: "产品/质量类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=6589&page=1"
        },
        {
          img: "sheji",
          name: "创意/设计类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=6590&page=1"
        },
        {
          img: "yunying",
          name: "运营/销售类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=6591&page=1"
        },
        {
          img: "mendian",
          name: "线下门店类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=16508&page=1"
        },
        // {
        //   img: "kefu",
        //   name: "客服类",
        //   url:
        //     "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=15857&page=1"
        // },
        {
          img: "jishu",
          name: "技术类",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=6588&page=1"
        },
        {
          img: "chaoji",
          name: "超级松鼠",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=21154&page=1"
        },
        {
          img: "shixi",
          name: "实习生",
          url:
            "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=16119&page=1"
        }
      ]
    };
  },
  methods: {
    initData() {
      this.slideStyle = {
        width: document.body.clientWidth + "px",
        height: document.body.clientHeight + "px"
      };
    },
    // 切换tab
    handleActivityTab(v) {
      this.activityTab = v;
    },
    // 跳转fullpage index
    toFullPageSwiper(v) {
      let swiper = this.$refs.fullPageSwiper.$swiper;
      if (swiper) {
        swiper.slideTo(v, 1000, false);
      }
    },
    toSearch1() {
      let searchPost = this.searchPost1.trim();
      let url =
        "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=&keyword=" +
        searchPost +
        "&page=1";
      window.open(url);
    },
    toSearch2() {
      let searchPost = this.searchPost2.trim();
      let url =
        "https://app.mokahr.com/campus_apply/3songshu/457#/jobs?zhineng=&keyword=" +
        searchPost +
        "&page=1";
      window.open(url);
    },
    openUrl(url) {
      window.open(url);
    }
  },
  mounted() {
    this.initData();
    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        let clientWidth = document.body.clientWidth;
        if (clientWidth <= 1200) {
          clientWidth = 1200;
        }
        this.screenWidth = clientWidth;
        this.screenHeight = document.body.clientHeight;
      })();
    };
  }
};
</script>

<style scoped lang="less">
@import "./jobs-school.less";
</style>
